import instance from "@/services/api";

export const snabzhentsAPI = {
  async getList(params) {
    return await instance().get('/supplier/snabzhents/read/', { params }).then(res => res?.data);
  },

  async getSbsProjects(search = '', page = 1, limit = 50) {
    return await instance().get('/project/sbs_project/read_all/', {
      params: { search, page, limit },
    }).then(res => res?.data);
  },

  async getRequiredTypes() {
    return await instance().get('/material/required_types/').then(res => res?.data);
  },
};
